import { render, staticRenderFns } from "./AuthorCard.vue?vue&type=template&id=4734c15c&scoped=true"
import script from "./AuthorCard.vue?vue&type=script&lang=js"
export * from "./AuthorCard.vue?vue&type=script&lang=js"
import style0 from "./AuthorCard.vue?vue&type=style&index=0&id=4734c15c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734c15c",
  null
  
)

export default component.exports